<template>
  <a-drawer
    title="权限配置"
    :width="720"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :body-style="{ paddingBottom: '80px' }"
  >
    <a-table
      :columns="columns"
      :dataSource="data"
      rowKey="id"
      :pagination="false"
      :loading="loading"
      bordered
    >
      <span slot="menus" slot-scope="data, record">
        <a-checkbox
          :checked="menuIds.includes(record.id)"
          :id="record.parentId ? record.parentId + '' : null"
          :name="record.name"
          :value="record.id"
          @change="menuChange"
          >{{ record.name }}</a-checkbox
        >
      </span>

      <span slot="btnAuthority" slot-scope="data">
        <a-checkbox
          v-for="(item, index) in data"
          :key="index"
          :checked="btnIds.includes(item.id)"
          :value="item.id"
          @change="btnChange"
          >{{ item.authName }}</a-checkbox
        >
      </span>
    </a-table>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1
      }"
    >
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="onClose"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button :loading="loading" type="primary" @click="handleSubmit"
        >保存</a-button
      >
    </div>
  </a-drawer>
</template>
<script>
import { findAll, findByRole as findMenus } from "@/api/system/menu";
import { findByRole as findAuths } from "@/api/system/authentication";
import { saveAuth } from "@/api/system/role";
const columns = [
  {
    title: "菜单名称",
    dataIndex: "name",
    scopedSlots: { customRender: "menus" }
  },
  {
    title: "权限名称(按钮名称)",
    dataIndex: "auths",
    scopedSlots: { customRender: "btnAuthority" }
  }
];

export default {
  name: "RoleDrawer",
  data() {
    return {
      id: "",
      visible: false,
      columns,
      data: [],
      menuIds: [],
      btnIds: [],
      loading: false
    };
  },
  methods: {
    async initData() {
      this.loading = true;
      let params = { roleId: this.id };
      //查询该角色拥有的菜单
      await findMenus({ ...params }).then(res => {
        this.getChildrenId(res.result);
      });
      //查询该角色用户的按钮权限
      await findAuths({ ...params }).then(res => {
        res.result.forEach(item => {
          this.btnIds.push(item.id);
        });
      });
      //查询所有菜单
      await findAll().then(res => {
        this.data = res.result;
      });
      this.loading = false;
    },
    getChildrenId(data) {
      data.forEach(item => {
        this.menuIds.push(item.id);
        if (item.children && item.children.length > 0) {
          this.getChildrenId(item.children);
        }
      });
    },
    showDrawer(id) {
      this.id = id;
      this.initData();
      this.visible = true;
    },
    onClose() {
      this.visible = false;
      this.menuIds = [];
      this.btnIds = [];
      this.data = [];
    },
    //菜单权限
    menuChange(e) {
      if (e.target.checked) {
        this.menuIds.push(e.target.value);
        if (e.target.id && !this.menuIds.includes(parseInt(e.target.id))) {
          this.menuIds.push(parseInt(e.target.id));
        }
      } else {
        this.menuIds.map((item, index) => {
          if (e.target.value == item) this.menuIds.splice(index, 1);
        });
      }
    },
    //按钮权限
    btnChange(e) {
      if (e.target.checked) {
        this.btnIds.push(e.target.value);
      } else {
        this.btnIds.map((item, index) => {
          if (e.target.value == item) this.btnIds.splice(index, 1);
        });
      }
    },
    handleSubmit() {
      this.loading = true;
      let params = {
        id: this.id,
        screenIds: this.menuIds.toString(),
        auths: this.btnIds.toString()
      };
      console.log(params);
      saveAuth({ ...params }).then(res => {
        this.$notification.success({
          message: res.message
        });
        this.loading = false;
        this.onClose();
        this.$emit("ok");
      });
    }
  }
};
</script>
